import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

/**
 * The portal talks to Firebase as the signed-in user; there is no server in between.
 *
 * A coach may write an athlete's plans only while that athlete has authorised them, which is a row
 * in the database the rules check on every request. The athlete grants it and can take it back, so
 * knowing a code is never enough on its own.
 */
const config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const firebaseApp = initializeApp(config);
export const auth = getAuth(firebaseApp);

export const isFirebaseConfigured = Boolean(config.apiKey && config.authDomain);
